import actions from "./actions";

const initState = {
    createNumberFormatState: null,
    createNumberFormatResult: {},
    readNumberFormatistState: null,
    numberFormats: [],
    pagination: {},
    readNumberFormatState: null,
    numberFormat: {},
    updateNumberFormatState: null,
    deleteNumberFormatState: null,

    numberFormatDrawerVisible: false,
    numberFormatDrawerMode: undefined, // 'create', 'update'
    numberFormatDrawerProps: {
        transactionType: undefined,
        initialTypeValue: undefined,
        enforceType: undefined,
    },
};

export default function appReducer(state = initState, action = {}) {
    switch (action.type) {
    /* Number Formats */
        case actions.NUMBER_FORMAT_SET:
            return {
                ...state,
                numberFormat: action.number_format,
            };
        case actions.NUMBER_FORMAT_CREATE_REQUEST:
            return {
                ...state,
                createNumberFormatState: 'request',
            };
        case actions.NUMBER_FORMAT_CREATE_SUCCESS:
            return {
                ...state,
                createNumberFormatState: 'success',
                createNumberFormatResult: action.number_format,
            };
        case actions.NUMBER_FORMAT_CREATE_FAIL:
            return {
                ...state,
                createNumberFormatState: 'fail',
            };
        case actions.NUMBER_FORMAT_READ_LIST_REQUEST:
            return {
                ...state,
                readNumberFormatListState: 'request',
            };
        case actions.NUMBER_FORMAT_READ_LIST_SUCCESS:
            return {
                ...state,
                readNumberFormatListState: 'success',
                numberFormats: action.number_formats,
                pagination: {
                    total: action.pagination.total,
                    current: action.pagination.current_page,
                    pageSize: action.pagination.per_page,
                },
            };
        case actions.NUMBER_FORMAT_READ_LIST_FAIL:
            return {
                ...state,
                readNumberFormatListState: 'fail',
            };
        case actions.NUMBER_FORMAT_READ_REQUEST:
            return {
                ...state,
                readNumberFormatState: 'request',
            };
        case actions.NUMBER_FORMAT_READ_SUCCESS:
            return {
                ...state,
                readNumberFormatState: 'success',
                numberFormat: action.number_format,
            };
        case actions.NUMBER_FORMAT_READ_FAIL:
            return {
                ...state,
                readNumberFormatState: 'fail',
            };
        case actions.NUMBER_FORMAT_UPDATE_REQUEST:
            return {
                ...state,
                updateNumberFormatState: 'request',
            };
        case actions.NUMBER_FORMAT_UPDATE_SUCCESS:
            return {
                ...state,
                updateNumberFormatState: 'success',
            };
        case actions.NUMBER_FORMAT_UPDATE_FAIL:
            return {
                ...state,
                updateNumberFormatState: 'fail',
            };
        case actions.NUMBER_FORMAT_DELETE_REQUEST:
            return {
                ...state,
                deleteNumberFormatState: 'request',
            };
        case actions.NUMBER_FORMAT_DELETE_SUCCESS:
            return {
                ...state,
                deleteNumberFormatState: 'success',
            };
        case actions.NUMBER_FORMAT_DELETE_FAIL:
            return {
                ...state,
                deleteNumberFormatState: 'fail',
            };
            /* OTHERS */
        case actions.NUMBER_FORMAT_RESET_STATE:
            return {
                ...initState,
            };
        case actions.NUMBER_FORMAT_TOGGLE_DRAWER:
            return {
                ...state,
                numberFormatDrawerVisible: action.visible,
                numberFormatDrawerMode: action.mode,
                numberFormatDrawerProps: action.drawerProps,
            };
        default:
            return state;
    }
}
